import {useEffect} from 'react'
import {Navigate, Routes, Route} from 'react-router-dom'
import {useAuth} from './core/Auth'

export function Logout() {
  const {logout} = useAuth()

  useEffect(() => {
    logout()
    // '/logout' doesn't exist on the v2 backend (logout is POST /auth/logout);
    // navigating there just bounced through the login page with next=%2Flogout.
    // Clear local auth and hand the user to the main-app login instead.
    window.location.replace(process.env.REACT_APP_OLD_FLASK_APP_URL + '/auth/login')
  }, [logout])

  return <Navigate to='/auth/login' />
}
